import styled from 'styled-components';

import { getThemeProp } from 'theme';

export const SItem = styled.div`
  align-items: center;
  background-color: ${getThemeProp('colors.alabasterGrey3')};
  color: ${getThemeProp('colors.doveGrey')};
  cursor: pointer;
  display: flex;
  font-size: 13px;
  justify-content: space-between;
  padding: 0 25px;

  &:hover {
    &,
    * {
      background: ${getThemeProp('colors.moodyBlue3')};
      color: ${getThemeProp('colors.white')} !important;
    }
  }
`;

export const SNameContainer = styled.span`
  display: inline-block;
  max-width: 55%;
  overflow: hidden;

  sup {
    color: ${getThemeProp('colors.manateeGrey2')};
    font-size: 10px;
    padding-left: 4.5px;
  }
`;

export const SNonHighlightableNamePart = styled.span`
  color: ${getThemeProp('colors.doveGrey')};
`;

export const SHeaderTitle = styled.span`
  text-transform: uppercase;
`;

export const SSecondaryInfoText = styled.span`
  font-size: 0.9em;
  font-weight: 300;
`;

export const SHeader = styled.div`
  align-items: center;
  border-bottom: 1px solid ${getThemeProp('colors.mercuryGrey')};
  display: flex;
  font-size: 11px;
  justify-content: flex-start;
  padding: 0 25px;

  * {
    color: ${getThemeProp('colors.manateeGrey')};
  }

  & > i {
    display: inline-block;
    font-size: 14px;
    margin-right: 7px;
    transform: translateY(2px);
  }

  & > span:last-child {
    margin-left: auto;
  }
`;
